import React from 'react';
import './Dashboard.css';

const DashboardCard = ({ title, value }) => {
  return (
    <div className="dashboard-card">
      <div className="card-title">{title}</div>
      <div className="card-value">{value}</div>
    </div>
  );
};


export default DashboardCard;
